import { useEffect, useState } from "react";
import api, { formatInr } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  return (
    <div>
      <div className="overline">Overview</div>
      <h1 className="font-display text-4xl tracking-tight mt-2">Dashboard</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
        <Card label="Revenue" value={stats ? formatInr(stats.revenue) : "…"} highlight />
        <Card label="Orders" value={stats?.orders ?? "…"} sub={`${stats?.pending_orders ?? 0} pending`} />
        <Card label="Enquiries" value={stats?.enquiries ?? "…"} sub={`${stats?.new_enquiries ?? 0} new`} />
        <Card label="Customers" value={stats?.customers ?? "…"} />
        <Card label="Products" value={stats?.products ?? "…"} />
      </div>

      <div className="mt-12 border border-[var(--fm-border)] p-8 bg-white">
        <div className="overline">Quick links</div>
        <div className="mt-4 grid sm:grid-cols-3 gap-3 text-sm">
          <a href="/admin/products" className="fm-btn-secondary text-center">Manage products</a>
          <a href="/admin/orders" className="fm-btn-secondary text-center">View orders</a>
          <a href="/admin/enquiries" className="fm-btn-secondary text-center">View enquiries</a>
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, sub, highlight }) {
  return (
    <div data-testid={`stat-${label.toLowerCase()}`} className={`p-6 border ${highlight ? "border-[var(--fm-primary)] bg-[var(--fm-sage)]" : "border-[var(--fm-border)] bg-white"}`}>
      <div className="overline">{label}</div>
      <div className="font-display text-3xl mt-2 text-[var(--fm-primary)]">{value}</div>
      {sub && <div className="text-xs text-[var(--fm-text-3)] mt-1">{sub}</div>}
    </div>
  );
}
